"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const driver_types_1 = require("./driver.types");
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataContractor: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        driver: '',
        driver_type: '',
        is_active: true,
        contractor: '',
        contractor_code: '',
        contractor_name: '',
        emp_no: '',
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const driverReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [driver_types_1.driverTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [driver_types_1.driverTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [driver_types_1.driverTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [driver_types_1.driverTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [driver_types_1.driverTypes.ON_DELETE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [driver_types_1.driverTypes.SET_DATA_CONTRACTOR]: (state, action) => {
        const contractor_data = action.payload.find(x => x.contractor_name === state.dataItem.contractor) ||
            {
                id: '0',
                contractor_code: '',
                contractor_name: '',
                contractor_type: '', is_active: {
                    status: 'Active',
                    value: true
                },
                modified_by: '',
                modified_date: new Date(),
                created_by: '',
                created_date: new Date(),
            };
        const newDataItem = Object.assign(Object.assign({}, state.dataItem), { contractor_data, contractor_code: contractor_data.id, contractor_name: state.dataItem.contractor });
        return Object.assign(Object.assign({}, state), { dataContractor: action.payload, dataItem: newDataItem });
    },
    [driver_types_1.driverTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [driver_types_1.driverTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [driver_types_1.driverTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [driver_types_1.driverTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    }
});
exports.default = driverReducer;
